var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificaciones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-push-notifications",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-push-notifications:not(.animated) .animable {opacity: 0;}svg#freepik_stories-push-notifications.animated #freepik--Device--inject-3 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-push-notifications.animated #freepik--Screen--inject-3 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-push-notifications.animated #freepik--Notifications--inject-3 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-push-notifications.animated #freepik--Character--inject-3 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3",
    className: "animable",
    style: {
      transformOrigin: "249.984px 338.737px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.21,245.05c-89.62-51.74-234.44-51.74-323.48,0s-88.57,135.63,1,187.37,234.45,51.75,323.49,0S500.84,296.79,411.21,245.05Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "249.984px 338.737px"
    },
    id: "elusm9sce4ull",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-3",
    className: "animable",
    style: {
      transformOrigin: "244.486px 356.741px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.61,336.32l74.82-43.17,90.89,52.45a3.57,3.57,0,0,1,0,6.18l-24.55,14.16c15.12-1.81,31.44.68,43.13,7.47,18.47,10.73,18.37,28.13-.21,38.87s-48.63,10.73-67.1,0c-11.7-6.8-15.94-16.27-12.75-25l-4.47,2.57a17.82,17.82,0,0,1-17.81,0L93.61,342.5A3.57,3.57,0,0,1,93.61,336.32Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "191.758px 356.741px"
    },
    id: "el0nr0rb068aw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.33,414.48l49.9-28.81a2.21,2.21,0,0,0,0-3.83l-44-25.56a2.19,2.19,0,0,0-2.21,0L44,385.73a2.21,2.21,0,0,0,0,3.83l42.87,24.91A4.43,4.43,0,0,0,91.33,414.48Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "92.615px 385.529px"
    },
    id: "elsgd3yhfe39r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.29,372c2.38,1.38,2.39,3.61,0,5l-9.73,5.61a9.47,9.47,0,0,1-8.61,0L319.19,320.92c-2.39-1.37-2.4-3.61,0-5l9.73-5.62a9.47,9.47,0,0,1,8.61,0Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "381.736px 346.455px"
    },
    id: "elsdf61nt2v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.33,380.82c2.39,1.38,2.4,3.61,0,5l-9.73,5.62a9.47,9.47,0,0,1-8.61,0l-91.2-52.68c-2.38-1.37-2.4-3.61,0-5l9.73-5.62a9.47,9.47,0,0,1,8.61,0Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "359.562px 359.79px"
    },
    id: "el9kty3txin1t",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-3",
    className: "animable",
    style: {
      transformOrigin: "87.45px 151.07px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "104.85 97.81 70 117.93 70.08 144.56 104.92 124.44 104.85 97.81",
    style: {
      fill: "none",
      transformOrigin: "87.46px 121.185px"
    },
    id: "elqyosx88akz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.85 97.81 104.92 124.44 108.15 126.32 108.06 95.95 104.85 97.81",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "106.5px 111.135px"
    },
    id: "el4fsora92uai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.08 144.56 70.09 148.29 108.15 126.32 104.92 124.44 70.08 144.56",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "89.115px 136.365px"
    },
    id: "elvbo6uknqds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,89.23,66.09,115.71,66.2,155l45.86-26.48ZM70.09,148.29v-3.73L70,117.93l34.85-20.12L108.06,96l.09,30.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "89.075px 122.115px"
    },
    id: "ellvgbihz6vy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.95 89.23 108.72 87.35 62.86 113.83 66.09 115.7 111.95 89.23",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "87.405px 101.525px"
    },
    id: "elnz5kvv16j6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.86 113.83 62.97 153.15 66.2 155.03 66.09 115.7 62.86 113.83",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "64.53px 134.43px"
    },
    id: "elhrq8z0cp0nd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.82 157.58 69.98 177.69 70.06 204.32 104.9 184.21 104.82 157.58",
    style: {
      fill: "none",
      transformOrigin: "87.44px 180.95px"
    },
    id: "elp8mjug4yn2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.82 157.58 104.9 184.21 108.13 186.08 108.04 155.72 104.82 157.58",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "106.475px 170.9px"
    },
    id: "elf9sj697u3si",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.06 204.32 70.07 208.06 108.13 186.08 104.9 184.21 70.06 204.32",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "89.095px 196.135px"
    },
    id: "elqmn9k2nquf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.93,149,66.07,175.47l.11,39.32L112,188.31ZM70.07,208.06v-3.74L70,177.69l34.84-20.11,3.22-1.86.09,30.36Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "89.035px 181.895px"
    },
    id: "el5ayrqbmz4n3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.93 148.99 108.7 147.12 62.84 173.59 66.07 175.47 111.93 148.99",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "87.385px 161.295px"
    },
    id: "el7d5t4mrjhsl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.84 173.59 62.95 212.91 66.18 214.79 66.07 175.47 62.84 173.59",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "64.51px 194.19px"
    },
    id: "el0vhr1wp48tta",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.78 107.92 103.28 115.41 103.3 122.71 71.69 140.96 71.67 133.65 77.7 121.69 83.11 125.89 81.19 131.83 83.97 126.55 93.78 107.92",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "87.485px 124.44px"
    },
    id: "elxlejsjjhebi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.39,111.61c1.49-.86,2.7-.17,2.71,1.54a5.93,5.93,0,0,1-2.69,4.65c-1.49.86-2.7.17-2.7-1.54A5.92,5.92,0,0,1,83.39,111.61Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "83.405px 114.705px"
    },
    id: "elrjt5zo58ls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.75 167.69 103.25 175.17 103.28 182.48 71.67 200.73 71.65 193.42 77.67 181.45 83.08 185.65 81.17 191.59 83.94 186.32 93.75 167.69",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "87.465px 184.21px"
    },
    id: "elonfah4jzs1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.37,171.37c1.49-.86,2.7-.17,2.7,1.54a5.89,5.89,0,0,1-2.68,4.65c-1.49.86-2.7.17-2.7-1.54A5.89,5.89,0,0,1,83.37,171.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "83.38px 174.465px"
    },
    id: "el9vcc8x9tro",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-3",
    className: "animable animator-active",
    style: {
      transformOrigin: "386.62px 217.145px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.92,130.88a9.78,9.78,0,0,0-3.94-4.22L339.32,68.26a4.57,4.57,0,0,0-1.48-.3c-5.28-.1-10.59,4.87-11.34,7.49h0a2.35,2.35,0,0,0-.26,1.07V298.47A9.81,9.81,0,0,0,331.2,307l102.66,58.5a3.2,3.2,0,0,0,.39.16l0,0c6.13,2.6,12.65-2.8,12.65-8.46v-222A9.8,9.8,0,0,0,445.92,130.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "386.57px 217.145px"
    },
    id: "el8kw4a64jegb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.51,75.46h0c.75-2.62,6.06-7.59,11.34-7.49a4.57,4.57,0,0,1,1.48.3L442,126.66a10,10,0,0,1,5,8.53v222c0,5.66-6.52,11.06-12.65,8.46l0,0a3.2,3.2,0,0,1-.39-.16L331.2,307a9.81,9.81,0,0,1-4.95-8.53V76.53A2.35,2.35,0,0,1,326.51,75.46Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "386.625px 217.145px"
    },
    id: "elqqesc4zfi8c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.62,158.66a4.94,4.94,0,0,0-2.48-4.27l-95.32-54.22a2.45,2.45,0,0,0-3.66,2.13V281.35a4.91,4.91,0,0,0,2.48,4.26L429,339.93a2.46,2.46,0,0,0,3.67-2.14Z",
    style: {
      fill: "current",
      transformOrigin: "381.915px 220.049px"
    },
    id: "elovwj7i59nvh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5oheq9iuy59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.62,158.66a4.94,4.94,0,0,0-2.48-4.27l-95.32-54.22a2.45,2.45,0,0,0-3.66,2.13V281.35a4.91,4.91,0,0,0,2.48,4.26L429,339.93a2.46,2.46,0,0,0,3.67-2.14Z",
    style: {
      opacity: 0.2,
      transformOrigin: "381.915px 220.049px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elw03icl89wyn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.94,135.19v222c0,5.66-6.52,11.06-12.65,8.46l0,0a2.45,2.45,0,0,0,3.28-2.29v-222a9.79,9.79,0,0,0-1.66-5.42l10.05-5A9.8,9.8,0,0,1,446.94,135.19Z",
    style: {
      opacity: 0.3,
      transformOrigin: "440.615px 248.631px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el52edlt4ymd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.84,68a4.57,4.57,0,0,1,1.48.3L442,126.66a9.78,9.78,0,0,1,3.94,4.22l-10.05,5a9.87,9.87,0,0,0-3.3-3.12L329.92,74.39a2.45,2.45,0,0,0-3.41,1.07h0C327.25,72.83,332.56,67.86,337.84,68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "386.225px 101.939px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.24,111.06c-.72-.42-1.32-.1-1.32.73a2.91,2.91,0,0,0,1.31,2.28l20.14,11.62c.72.42,1.3.07,1.3-.76a2.83,2.83,0,0,0-1.29-2.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "379.295px 118.372px"
    },
    id: "el51fjkyo3yus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.55,125.67c-.72-.41-1.31-.08-1.31.75a2.91,2.91,0,0,0,1.3,2.26c.72.42,1.32.07,1.32-.75A2.9,2.9,0,0,0,394.55,125.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "394.55px 127.176px"
    },
    id: "el4n3yp73lidv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.66,109.37c-1.44-.83-2.61-.17-2.61,1.48a5.76,5.76,0,0,0,2.59,4.53c1.44.83,2.63.15,2.64-1.51A5.77,5.77,0,0,0,381.66,109.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.665px 112.373px"
    },
    id: "elcs9x9lz9tns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.65,318.4c-2.93-1.69-5.3-.35-5.31,3a11.73,11.73,0,0,0,5.27,9.21c2.94,1.69,5.37.31,5.38-3.07A11.72,11.72,0,0,0,381.65,318.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.665px 324.501px"
    },
    id: "el71e38w9s9bw",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-3",
    className: "animable",
    style: {
      transformOrigin: "362.27px 242.169px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417,166.74a9,9,0,0,0-.86-2.88,9.21,9.21,0,0,0-.67-1.14,8.87,8.87,0,0,0-2.91-2.7l-93.18-53-.14-.06a3,3,0,0,0-.38-.1,5.31,5.31,0,0,0-.83-.1,9.76,9.76,0,0,0-4.37,1,14.92,14.92,0,0,0-3.63,2.52l-.57.57a7.34,7.34,0,0,0-1.72,2.65h0a2.29,2.29,0,0,0-.17.46,1.7,1.7,0,0,0-.07.51V316h0a8.95,8.95,0,0,0,4.5,7.74l93.18,53.1a2.67,2.67,0,0,0,.36.14l0,0c5.56,2.36,11.48-2.54,11.48-7.68V167.77h0A8.77,8.77,0,0,0,417,166.74Z",
    style: {
      fill: "current",
      transformOrigin: "362.263px 242.175px"
    },
    id: "elmx1ljr606ob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.72,113.55h0c.68-2.37,5.5-6.89,10.29-6.79a4.14,4.14,0,0,1,1.35.26l93.18,53a9,9,0,0,1,3.58,3.84,8.85,8.85,0,0,1,.92,3.91V369.31c0,5.14-5.92,10-11.48,7.68l0,0a2.67,2.67,0,0,1-.36-.14L312,323.72a8.92,8.92,0,0,1-4.5-7.74V114.52A2.21,2.21,0,0,1,307.72,113.55Z",
    style: {
      fill: "current",
      transformOrigin: "362.27px 242.172px"
    },
    id: "ell95a1jbpqhs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfkhvyrgulxe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417,167.77V369.31c0,5.14-5.92,10-11.48,7.68l0,0a2.21,2.21,0,0,0,3-2.08V173.34a8.89,8.89,0,0,0-1.5-4.92l9.12-4.56A8.85,8.85,0,0,1,417,167.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "411.26px 270.723px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwyn9dbekkge"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318,106.75a4.14,4.14,0,0,1,1.35.26l93.18,53a9,9,0,0,1,3.58,3.84L407,168.42a8.85,8.85,0,0,0-3-2.83l-93.18-53a2.21,2.21,0,0,0-3.09,1h0C308.39,111.17,313.21,106.65,318,106.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "361.92px 137.584px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2r0j1twv9ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.72,113.55h0c.68-2.37,5.5-6.89,10.29-6.79a4.14,4.14,0,0,1,1.35.26l93.18,53a9,9,0,0,1,3.58,3.84,8.85,8.85,0,0,1,.92,3.91V369.31c0,5.14-5.92,10-11.48,7.68l0,0a2.67,2.67,0,0,1-.36-.14L312,323.72a8.92,8.92,0,0,1-4.5-7.74V114.52A2.21,2.21,0,0,1,307.72,113.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "362.27px 242.172px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "316.88 125.47 317.92 126.08 317.94 121.59 316.89 120.99 316.88 125.47",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "317.41px 123.535px"
    },
    id: "ellpfbb57o7hk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.09 124.44 316.13 125.04 316.14 121.41 315.1 120.81 315.09 124.44",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "315.615px 122.925px"
    },
    id: "elfahk8que1g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.29 123.4 314.33 124 314.34 121.31 313.3 120.71 313.29 123.4",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313.815px 122.355px"
    },
    id: "eln4m9iyeyej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.5 122.37 312.54 122.97 312.54 121.15 311.5 120.55 311.5 122.37",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "312.02px 121.76px"
    },
    id: "elg898dcm542",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.76 127.72 327.15 131.41 327.16 127.64 320.77 123.95 320.76 127.72",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "323.96px 127.68px"
    },
    id: "elfiwzj18cata",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.33 133.24 333.52 135.08 333.53 131.32 330.34 129.48 330.33 133.24",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "331.93px 132.28px"
    },
    id: "elagz4ay8jew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.26 170.83 396.27 167.8 399.7 169.78 396.27 167.8 396.26 170.83",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "397.98px 169.315px"
    },
    id: "el9g9gnhl2quf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.26 170.83 399.69 172.81 399.7 169.78 396.27 167.8 396.26 170.83",
    style: {
      fill: "current",
      transformOrigin: "397.98px 170.305px"
    },
    id: "elytp4yraicp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.12,171.63v-1.18l-6.48-3.74v4.48l6.48,3.74v-1.18l.83.48v-2.12Zm-2.43,1.18-3.43-2v-3l3.43,2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "399.295px 170.82px"
    },
    id: "elupoypkfns9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.36 165.52 392.75 169.2 392.76 165.44 386.37 161.75 386.36 165.52",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "389.56px 165.475px"
    },
    id: "el2i5omsojqt3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.87 147.69 362.26 151.38 362.27 147.62 355.88 143.93 355.87 147.69",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "359.07px 147.655px"
    },
    id: "elp2n3b8713e",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notifications--inject-3",
    className: "animable",
    style: {
      transformOrigin: "328.509px 248.596px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.48,183.51,297.59,129.3a2,2,0,0,0-1.87-.22h0l-.05,0h0l-2,1.14,1.23,1.22-.07,26.81v.63l0,7.23a6,6,0,0,0,2.71,4.7L387.77,223l3.47,3.42,1.94-1.11a1.06,1.06,0,0,0,.2-.12l.09,0h0a2,2,0,0,0,.63-1.61l0-6.62v-1.24l.08-27.43A6,6,0,0,0,391.48,183.51Z",
    style: {
      fill: "current",
      transformOrigin: "343.925px 177.681px"
    },
    id: "el6ds56ugz53b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elku2y1lorall"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.48,183.51,297.59,129.3a2,2,0,0,0-1.87-.22h0l-.05,0h0l-2,1.14,1.23,1.22-.07,26.81v.63l0,7.23a6,6,0,0,0,2.71,4.7L387.77,223l3.47,3.42,1.94-1.11a1.06,1.06,0,0,0,.2-.12l.09,0h0a2,2,0,0,0,.63-1.61l0-6.62v-1.24l.08-27.43A6,6,0,0,0,391.48,183.51Z",
    style: {
      opacity: 0.2,
      transformOrigin: "343.925px 177.681px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.47,184.64a6,6,0,0,1,2.71,4.7l-.08,27.42-99.33-57.34v1.25L392.1,218l0,6.61c0,1.73-1.23,2.43-2.73,1.56L295.46,172a6,6,0,0,1-2.71-4.69l.1-35.29c0-1.72,1.22-2.42,2.73-1.56Z",
    style: {
      fill: "current",
      transformOrigin: "342.465px 178.318px"
    },
    id: "eleoq5gu306k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.1 216.76 392.1 218.01 292.77 160.67 292.77 159.42 392.1 216.76",
    style: {
      fill: "current",
      transformOrigin: "342.435px 188.715px"
    },
    id: "elyglvmzyj29r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elttsbn3y9jyj"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "342.435px 188.715px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "392.1 216.76 392.1 218.01 292.77 160.67 292.77 159.42 392.1 216.76",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "342.435px 188.715px"
    },
    id: "eloz8axzhsyxs",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el9f80ojl6v8n"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "319.74px 180.91px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "343.58 193.14 343.57 196.2 295.9 168.67 295.91 165.62 343.58 193.14",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "319.74px 180.91px"
    },
    id: "elx2225s0uve",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M313.59,144.67a3.59,3.59,0,0,1,1.62,2.82l0,18.34c0,1-.73,1.45-1.64.93l-15.95-9.22a3.57,3.57,0,0,1-1.63-2.81l.05-18.34c0-1,.74-1.46,1.64-.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "305.6px 151.106px"
    },
    id: "eljx5cwmkx2zn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el97piaqud6bi"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "346.62px 167.695px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "371.88 180.27 371.87 184.28 321.36 155.12 321.37 151.11 371.88 180.27",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "346.62px 167.695px"
    },
    id: "ely63kbie4hz",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ellte59gh2zb"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "335.425px 175.325px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "349.53 181.46 349.52 185.47 321.32 169.19 321.33 165.18 349.53 181.46",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "335.425px 175.325px"
    },
    id: "elwy41odcy6uh",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elrwahjl6qknn"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "346.6px 174.73px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "371.86 187.31 371.85 191.31 321.34 162.15 321.35 158.15 371.86 187.31",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "346.6px 174.73px"
    },
    id: "elhq1ap6mn6ve",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el4atrn8c03cj"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "386.07px 189.245px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "388.34 187.99 386.82 189.35 388.61 193.06 387.11 192.19 386.03 189.85 385.04 191 383.53 190.12 385.36 188.51 383.9 185.43 385.38 186.28 386.16 188 386.84 187.13 388.34 187.99",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "386.07px 189.245px"
    },
    id: "eltbvp5bwe71a",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M391.48,233.46l-93.89-54.21a2,2,0,0,0-1.87-.21h0l-.05,0h0l-2,1.14,1.23,1.22-.07,26.81v.63l0,7.23a6,6,0,0,0,2.71,4.69l90.3,52.14,3.47,3.42,1.94-1.12a1,1,0,0,0,.2-.11l.09-.05h0a2,2,0,0,0,.63-1.61l0-6.62v-1.25l.08-27.42A6,6,0,0,0,391.48,233.46Z",
    style: {
      fill: "current",
      transformOrigin: "343.96px 227.609px"
    },
    id: "elksdr05qza6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elryym7iiux1m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.48,233.46l-93.89-54.21a2,2,0,0,0-1.87-.21h0l-.05,0h0l-2,1.14,1.23,1.22-.07,26.81v.63l0,7.23a6,6,0,0,0,2.71,4.69l90.3,52.14,3.47,3.42,1.94-1.12a1,1,0,0,0,.2-.11l.09-.05h0a2,2,0,0,0,.63-1.61l0-6.62v-1.25l.08-27.42A6,6,0,0,0,391.48,233.46Z",
    style: {
      opacity: 0.2,
      transformOrigin: "343.96px 227.609px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.47,234.6a6,6,0,0,1,2.71,4.7l-.08,27.42-99.33-57.34v1.24L392.1,268l0,6.61c0,1.73-1.23,2.43-2.73,1.56l-93.89-54.21a6,6,0,0,1-2.71-4.69l.1-35.29c0-1.73,1.22-2.43,2.73-1.56Z",
    style: {
      fill: "current",
      transformOrigin: "342.475px 228.295px"
    },
    id: "el9okr4z1pho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.1 266.72 392.1 267.97 292.77 210.62 292.77 209.38 392.1 266.72",
    style: {
      fill: "current",
      transformOrigin: "342.435px 238.675px"
    },
    id: "els0jc9eumzg9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwid2ty93lhd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "342.435px 238.675px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "392.1 266.72 392.1 267.97 292.77 210.62 292.77 209.38 392.1 266.72",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "342.435px 238.675px"
    },
    id: "elaoty7cphzto",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M313.59,194.63a3.59,3.59,0,0,1,1.62,2.82l0,18.33c0,1-.73,1.45-1.64.94l-15.95-9.22a3.57,3.57,0,0,1-1.63-2.82l.05-18.33c0-1,.74-1.46,1.64-.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "305.6px 201.063px"
    },
    id: "elbu5dwwv9nds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrpecaqmmghh"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "346.62px 217.65px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "371.88 230.23 371.87 234.24 321.36 205.07 321.37 201.06 371.88 230.23",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "346.62px 217.65px"
    },
    id: "elty2ki2qnh7c",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elm988w3h26"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "386.07px 239.2px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "388.34 237.95 386.82 239.31 388.61 243.01 387.11 242.15 386.03 239.81 385.04 240.95 383.53 240.08 385.36 238.47 383.9 235.39 385.38 236.24 386.16 237.96 386.84 237.09 388.34 237.95",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "386.07px 239.2px"
    },
    id: "elzcvoxztmv4r",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eledowq70satb"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "295.91 215.58 295.9 218.63 323.61 234.63 323.61 231.57 295.91 215.58",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "309.755px 225.105px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3fu349fzfk5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "321.35 208.1 321.34 212.11 345.43 226.01 345.43 222 321.35 208.1",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "333.385px 217.055px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.48,334.07l-93.89-54.21a2,2,0,0,0-1.87-.22h0l-.05,0h0l-2,1.14,1.23,1.22-.07,26.81v.63l0,7.23a6,6,0,0,0,2.71,4.7l90.3,52.13,3.47,3.42,1.94-1.11.2-.11.09-.06h0a2,2,0,0,0,.63-1.61l0-6.61v-1.25l.08-27.43A6,6,0,0,0,391.48,334.07Z",
    style: {
      fill: "current",
      transformOrigin: "343.96px 328.211px"
    },
    id: "elqaecqc5jedj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elg6avbwy6ulu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.48,334.07l-93.89-54.21a2,2,0,0,0-1.87-.22h0l-.05,0h0l-2,1.14,1.23,1.22-.07,26.81v.63l0,7.23a6,6,0,0,0,2.71,4.7l90.3,52.13,3.47,3.42,1.94-1.11.2-.11.09-.06h0a2,2,0,0,0,.63-1.61l0-6.61v-1.25l.08-27.43A6,6,0,0,0,391.48,334.07Z",
    style: {
      opacity: 0.2,
      transformOrigin: "343.96px 328.211px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.47,335.21a6,6,0,0,1,2.71,4.69l-.08,27.43L292.77,310v1.25l99.33,57.34,0,6.62c0,1.72-1.23,2.42-2.73,1.56l-93.89-54.21a6,6,0,0,1-2.71-4.7l.1-35.28c0-1.73,1.22-2.43,2.73-1.56Z",
    style: {
      fill: "current",
      transformOrigin: "342.475px 328.892px"
    },
    id: "elcs3x2hj474j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.1 367.33 392.1 368.57 292.77 311.23 292.77 309.98 392.1 367.33",
    style: {
      fill: "current",
      transformOrigin: "342.435px 339.275px"
    },
    id: "el3ykj1h5kqaa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxhds9vjsuc9"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "342.435px 339.275px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "392.1 367.33 392.1 368.57 292.77 311.23 292.77 309.98 392.1 367.33",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "342.435px 339.275px"
    },
    id: "eljqxvwgpojm",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M313.59,295.23a3.6,3.6,0,0,1,1.62,2.82l0,18.34c0,1-.73,1.45-1.64.93l-15.95-9.21a3.59,3.59,0,0,1-1.63-2.82L296,287c0-1,.74-1.45,1.64-.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "305.6px 301.695px"
    },
    id: "eloprwdblggy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3spho9z7tlc"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "346.62px 318.255px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "371.88 330.83 371.87 334.84 321.36 305.68 321.37 301.67 371.88 330.83",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "346.62px 318.255px"
    },
    id: "ellzp0oah8gi",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elp9jpr3pvg2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "386.07px 339.805px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "388.34 338.56 386.82 339.92 388.61 343.62 387.11 342.76 386.03 340.42 385.04 341.56 383.53 340.69 385.36 339.07 383.9 335.99 385.38 336.85 386.16 338.57 386.84 337.69 388.34 338.56",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "386.07px 339.805px"
    },
    id: "elayg31trvlrj",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el4qjno0dabpt"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "295.91 316.18 295.9 319.24 323.61 335.23 323.61 332.17 295.91 316.18",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "309.755px 325.705px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxpt5d2btfcm"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "321.35 308.71 321.34 312.71 332.23 318.99 332.23 314.98 321.35 308.71",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "326.785px 313.85px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.48,283.42l-93.89-54.21a1.94,1.94,0,0,0-1.87-.21h0l-.05,0h0l-2,1.15,1.23,1.21-.07,26.82v.63l0,7.23a6,6,0,0,0,2.71,4.69l90.3,52.14,3.47,3.42,1.94-1.12.2-.11.09-.05h0a2,2,0,0,0,.63-1.62l0-6.61v-1.25l.08-27.42A6,6,0,0,0,391.48,283.42Z",
    style: {
      fill: "current",
      transformOrigin: "343.96px 277.571px"
    },
    id: "eliistjijpanq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elinoczo2rjog"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.48,283.42l-93.89-54.21a1.94,1.94,0,0,0-1.87-.21h0l-.05,0h0l-2,1.15,1.23,1.21-.07,26.82v.63l0,7.23a6,6,0,0,0,2.71,4.69l90.3,52.14,3.47,3.42,1.94-1.12.2-.11.09-.05h0a2,2,0,0,0,.63-1.62l0-6.61v-1.25l.08-27.42A6,6,0,0,0,391.48,283.42Z",
    style: {
      opacity: 0.2,
      transformOrigin: "343.96px 277.571px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.47,284.56a6,6,0,0,1,2.71,4.69l-.08,27.43-99.33-57.35v1.25l99.33,57.35,0,6.61c0,1.73-1.23,2.42-2.73,1.56l-93.89-54.21a6,6,0,0,1-2.71-4.69l.1-35.29c0-1.73,1.22-2.43,2.73-1.56Z",
    style: {
      fill: "current",
      transformOrigin: "342.475px 278.223px"
    },
    id: "elfne4eos368a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.1 316.68 392.1 317.93 292.77 260.58 292.77 259.33 392.1 316.68",
    style: {
      fill: "current",
      transformOrigin: "342.435px 288.63px"
    },
    id: "elovbdkvvpz5l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela0hjgbz0ych"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "342.435px 288.63px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "392.1 316.68 392.1 317.93 292.77 260.58 292.77 259.33 392.1 316.68",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "342.435px 288.63px"
    },
    id: "elt5pjmuh8apt",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el21r8imq7ajpk"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "313.63px 277.35px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "331.36 286.11 331.35 289.16 295.9 268.59 295.91 265.54 331.36 286.11",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313.63px 277.35px"
    },
    id: "el739fwx5ekf",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M313.59,244.58a3.6,3.6,0,0,1,1.62,2.82l0,18.34c0,1-.73,1.45-1.64.93l-15.95-9.21a3.57,3.57,0,0,1-1.63-2.82l.05-18.33c0-1,.74-1.46,1.64-.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "305.6px 251.021px"
    },
    id: "elagp8q6s0fqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfe0i8gcbfij"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "346.62px 267.605px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "371.88 280.18 371.87 284.19 321.36 255.03 321.37 251.02 371.88 280.18",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "346.62px 267.605px"
    },
    id: "elj2oiv7k4t2",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elvyzruikf5zp"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "342.145px 279.165px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "362.97 289.22 362.96 293.23 321.32 269.11 321.33 265.1 362.97 289.22",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "342.145px 279.165px"
    },
    id: "el8qss8089vm6",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elfnw0zqh9608"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "346.6px 274.645px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "371.86 287.22 371.85 291.23 321.34 262.07 321.35 258.06 371.86 287.22",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "346.6px 274.645px"
    },
    id: "elgkkhg7temeo",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elpuitpgo8kzb"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "386.07px 289.16px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "388.34 287.91 386.82 289.27 388.61 292.97 387.11 292.11 386.03 289.77 385.04 290.91 383.53 290.04 385.36 288.43 383.9 285.35 385.38 286.2 386.16 287.92 386.84 287.05 388.34 287.91",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "386.07px 289.16px"
    },
    id: "elztlz3vdydy",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,129.93l-16.74-9.6c-1.46-.84-4.93.3-4.93,2.66a1.09,1.09,0,0,1,1.63-.95l16.73,9.6A3.17,3.17,0,0,1,282.4,133l3.25-1.85A3.25,3.25,0,0,0,284.44,129.93Z",
    style: {
      fill: "current",
      transformOrigin: "274.21px 126.527px"
    },
    id: "elrx40417yoke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4,133a3.19,3.19,0,0,1,.37,1.46v19.21a1.09,1.09,0,0,1-1.63.94,3.23,3.23,0,0,0,4.94-2.65V132.76a3.3,3.3,0,0,0-.43-1.6Z",
    style: {
      fill: "current",
      transformOrigin: "283.61px 143.13px"
    },
    id: "elqq2il8cdiji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el70mgq3ncjx8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.44,129.93l-16.74-9.6c-1.46-.84-4.93.3-4.93,2.66a1.09,1.09,0,0,1,1.63-.95l16.73,9.6A3.17,3.17,0,0,1,282.4,133l3.25-1.85A3.25,3.25,0,0,0,284.44,129.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "274.21px 126.527px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwsnthj57sdh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.4,133a3.19,3.19,0,0,1,.37,1.46v19.21a1.09,1.09,0,0,1-1.63.94,3.23,3.23,0,0,0,4.94-2.65V132.76a3.3,3.3,0,0,0-.43-1.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "283.61px 143.13px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.4,122l16.73,9.6a3.25,3.25,0,0,1,1.64,2.83v19.21a1.09,1.09,0,0,1-1.63.94l-16.73-9.56a3.25,3.25,0,0,1-1.64-2.83V123A1.09,1.09,0,0,1,264.4,122Z",
    style: {
      fill: "current",
      transformOrigin: "272.769px 138.29px"
    },
    id: "el0e52fupgg0rr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.8,144.87l-4,.75v-5.16l4.16,3.94A.28.28,0,0,1,286.8,144.87Z",
    style: {
      fill: "current",
      transformOrigin: "284.919px 143.04px"
    },
    id: "elwku38nn6aij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.78,140.46l3.3-1.89,4.16,4a.28.28,0,0,1-.06.44l-3.29,1.84Z",
    style: {
      fill: "current",
      transformOrigin: "286.55px 141.71px"
    },
    id: "eles92giwuewf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwozdwr5it6k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.78,140.46l3.3-1.89,4.16,4a.28.28,0,0,1-.06.44l-3.29,1.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "286.55px 141.71px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.71,143.5a4.36,4.36,0,0,0,1.77,2.71l.08,0c.91.53,1.8.27,1.91-.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "272.59px 144.992px"
    },
    id: "el55bct67h4fk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08,139.14a3.4,3.4,0,0,0,.48-1.63c.06-.84.08-1.71.11-2.57.06-1.77.77-2.7,2.15-2.78.33,0,.4-.13.35-.59-.09-.77.13-1.23.65-1.32a1.19,1.19,0,0,1,.8.17,2.59,2.59,0,0,1,.81.76,2.81,2.81,0,0,1,.64,2.06,1,1,0,0,0,.34,1,8.9,8.9,0,0,1,2,4.28,12.35,12.35,0,0,1,.09,1.58,17.71,17.71,0,0,0,.18,2.77,7,7,0,0,0,1,2.75,1.42,1.42,0,0,1,.27.86c0,.45-.18.56-.59.33L272.58,144l-3.89-2.25-.5-.29-.51-.29a1,1,0,0,1-.43-.51c-.16-.39-.09-.88.15-1A1.4,1.4,0,0,0,268.08,139.14Zm3.7-.1,1.63.94.42-4.25-2.44-1.41.39,4.72m.81,3.35c.7.41,1.19.13,1.19-.56a2.39,2.39,0,0,0-1.19-1.91c-.7-.4-1.19-.16-1.19.54a2.43,2.43,0,0,0,1.19,1.93m0-10.83c-.27-.16-.5,0-.5.29a1.14,1.14,0,0,0,.5.85h0a.3.3,0,0,0,.48-.28,1,1,0,0,0-.49-.86",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "272.557px 138.582px"
    },
    id: "elm37yglp627g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,181.75l-16.74-9.6c-1.46-.84-4.93.3-4.93,2.65a1.09,1.09,0,0,1,1.63-.94l16.73,9.6a3.17,3.17,0,0,1,1.27,1.37l3.25-1.85A3.25,3.25,0,0,0,284.44,181.75Z",
    style: {
      fill: "current",
      transformOrigin: "274.21px 178.352px"
    },
    id: "elsfstlx1xpcf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4,184.83a3.19,3.19,0,0,1,.37,1.46V205.5a1.09,1.09,0,0,1-1.63.94,3.23,3.23,0,0,0,4.94-2.66v-19.2a3.27,3.27,0,0,0-.43-1.6Z",
    style: {
      fill: "current",
      transformOrigin: "283.61px 194.955px"
    },
    id: "elxlfbzwkwuyo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbgohpuuii64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.44,181.75l-16.74-9.6c-1.46-.84-4.93.3-4.93,2.65a1.09,1.09,0,0,1,1.63-.94l16.73,9.6a3.17,3.17,0,0,1,1.27,1.37l3.25-1.85A3.25,3.25,0,0,0,284.44,181.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "274.21px 178.352px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz8g2ku4gc8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.4,184.83a3.19,3.19,0,0,1,.37,1.46V205.5a1.09,1.09,0,0,1-1.63.94,3.23,3.23,0,0,0,4.94-2.66v-19.2a3.27,3.27,0,0,0-.43-1.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "283.61px 194.955px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.4,173.86l16.73,9.6a3.25,3.25,0,0,1,1.64,2.83V205.5a1.09,1.09,0,0,1-1.63.94l-16.73-9.56a3.25,3.25,0,0,1-1.64-2.84V174.8A1.09,1.09,0,0,1,264.4,173.86Z",
    style: {
      fill: "current",
      transformOrigin: "272.77px 190.15px"
    },
    id: "el29izbemi7j4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.8,196.69l-4,.75v-5.16l4.16,3.94A.28.28,0,0,1,286.8,196.69Z",
    style: {
      fill: "current",
      transformOrigin: "284.919px 194.86px"
    },
    id: "elbgbfud1vr4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.78,192.28l3.3-1.89,4.16,4a.28.28,0,0,1-.06.44l-3.29,1.84Z",
    style: {
      fill: "current",
      transformOrigin: "286.55px 193.53px"
    },
    id: "el69o9ykul6ak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elz6jvv0pa4bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.78,192.28l3.3-1.89,4.16,4a.28.28,0,0,1-.06.44l-3.29,1.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "286.55px 193.53px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.71,195.31a4.36,4.36,0,0,0,1.77,2.72l.08,0c.91.53,1.8.26,1.91-.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "272.59px 196.806px"
    },
    id: "ela3k7xwwfai4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08,191a3.33,3.33,0,0,0,.48-1.62c.06-.84.08-1.71.11-2.57.06-1.78.77-2.7,2.15-2.78.33,0,.4-.13.35-.59-.09-.77.13-1.23.65-1.32a1.13,1.13,0,0,1,.8.17,2.59,2.59,0,0,1,.81.76,2.81,2.81,0,0,1,.64,2.06,1,1,0,0,0,.34,1,8.9,8.9,0,0,1,2,4.28,12.35,12.35,0,0,1,.09,1.58,17.71,17.71,0,0,0,.18,2.77,7,7,0,0,0,1,2.75,1.42,1.42,0,0,1,.27.86c0,.45-.18.56-.59.33l-4.83-2.79-3.89-2.25-.5-.29-.51-.29a1,1,0,0,1-.43-.51c-.16-.39-.09-.88.15-1A1.36,1.36,0,0,0,268.08,191Zm3.7-.09,1.63.93.42-4.24-2.44-1.41.39,4.72m.81,3.35c.7.4,1.19.13,1.19-.56a2.39,2.39,0,0,0-1.19-1.91c-.7-.41-1.19-.16-1.19.54a2.43,2.43,0,0,0,1.19,1.93m0-10.83c-.27-.16-.5,0-.5.28a1.14,1.14,0,0,0,.5.86h0a.3.3,0,0,0,.48-.28,1,1,0,0,0-.49-.86",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "272.532px 190.451px"
    },
    id: "ellyjuebbeqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,233.57,267.7,224c-1.46-.84-4.93.3-4.93,2.65a1.09,1.09,0,0,1,1.63-.94l16.73,9.6a3.17,3.17,0,0,1,1.27,1.37l3.25-1.85A3.25,3.25,0,0,0,284.44,233.57Z",
    style: {
      fill: "current",
      transformOrigin: "274.21px 230.202px"
    },
    id: "el02evwdlc5kfs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4,236.65a3.19,3.19,0,0,1,.37,1.46v19.2a1.09,1.09,0,0,1-1.63.95,3.23,3.23,0,0,0,4.94-2.66V236.4a3.27,3.27,0,0,0-.43-1.6Z",
    style: {
      fill: "current",
      transformOrigin: "283.61px 246.775px"
    },
    id: "elpj9mcnrvhe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el00aekbnzxfj1q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.44,233.57,267.7,224c-1.46-.84-4.93.3-4.93,2.65a1.09,1.09,0,0,1,1.63-.94l16.73,9.6a3.17,3.17,0,0,1,1.27,1.37l3.25-1.85A3.25,3.25,0,0,0,284.44,233.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "274.21px 230.202px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "els0jaw8nk3ip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.4,236.65a3.19,3.19,0,0,1,.37,1.46v19.2a1.09,1.09,0,0,1-1.63.95,3.23,3.23,0,0,0,4.94-2.66V236.4a3.27,3.27,0,0,0-.43-1.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "283.61px 246.775px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.4,225.68l16.73,9.6a3.25,3.25,0,0,1,1.64,2.83v19.2a1.09,1.09,0,0,1-1.63.95l-16.73-9.56a3.26,3.26,0,0,1-1.64-2.84V226.62A1.09,1.09,0,0,1,264.4,225.68Z",
    style: {
      fill: "current",
      transformOrigin: "272.77px 241.97px"
    },
    id: "elwmf6plxa9tm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.8,248.51l-4,.75V244.1l4.16,3.93A.28.28,0,0,1,286.8,248.51Z",
    style: {
      fill: "current",
      transformOrigin: "284.923px 246.68px"
    },
    id: "el8my3jkby7cn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.78,244.1l3.3-1.89,4.16,4a.28.28,0,0,1-.06.44l-3.29,1.84Z",
    style: {
      fill: "current",
      transformOrigin: "286.55px 245.35px"
    },
    id: "elzop4ws5i99c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldepkx03askh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.78,244.1l3.3-1.89,4.16,4a.28.28,0,0,1-.06.44l-3.29,1.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "286.55px 245.35px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.71,247.13a4.31,4.31,0,0,0,1.77,2.71l.08,0c.91.52,1.8.26,1.91-.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "272.59px 248.619px"
    },
    id: "el12xg8dwhfdx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08,242.77a3.33,3.33,0,0,0,.48-1.62c.06-.84.08-1.71.11-2.57.06-1.78.77-2.7,2.15-2.78.33,0,.4-.13.35-.59-.09-.77.13-1.23.65-1.32a1.13,1.13,0,0,1,.8.17,2.59,2.59,0,0,1,.81.76,2.8,2.8,0,0,1,.64,2.06,1,1,0,0,0,.34,1,8.9,8.9,0,0,1,2,4.28,12.35,12.35,0,0,1,.09,1.58,17.51,17.51,0,0,0,.18,2.76,7.08,7.08,0,0,0,1,2.76,1.4,1.4,0,0,1,.27.86c0,.45-.18.56-.59.33l-4.83-2.79-3.89-2.25-.5-.29-.51-.29a1,1,0,0,1-.43-.52c-.16-.38-.09-.87.15-1A1.36,1.36,0,0,0,268.08,242.77Zm3.7-.09,1.63.93.42-4.24L271.39,238l.39,4.72m.81,3.35c.7.4,1.19.12,1.19-.56a2.39,2.39,0,0,0-1.19-1.91c-.7-.41-1.19-.16-1.19.53a2.43,2.43,0,0,0,1.19,1.94m0-10.83c-.27-.16-.5,0-.5.28a1.1,1.1,0,0,0,.5.85h0c.26.15.48,0,.48-.29a1,1,0,0,0-.49-.85",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "272.532px 242.221px"
    },
    id: "elgnlnagoymyl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,285.39l-16.74-9.6c-1.46-.85-4.93.29-4.93,2.65a1.08,1.08,0,0,1,1.63-.94l16.73,9.6a3.17,3.17,0,0,1,1.27,1.37l3.25-1.85A3.18,3.18,0,0,0,284.44,285.39Z",
    style: {
      fill: "current",
      transformOrigin: "274.21px 281.99px"
    },
    id: "el0jtvob51ltv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4,288.47a3.19,3.19,0,0,1,.37,1.46v19.2a1.09,1.09,0,0,1-1.63.95,3.23,3.23,0,0,0,4.94-2.66v-19.2a3.27,3.27,0,0,0-.43-1.6Z",
    style: {
      fill: "current",
      transformOrigin: "283.61px 298.595px"
    },
    id: "eld4wyb0b1ueg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1bgmn816hwy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.44,285.39l-16.74-9.6c-1.46-.85-4.93.29-4.93,2.65a1.08,1.08,0,0,1,1.63-.94l16.73,9.6a3.17,3.17,0,0,1,1.27,1.37l3.25-1.85A3.18,3.18,0,0,0,284.44,285.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "274.21px 281.99px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhrwh72eipm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.4,288.47a3.19,3.19,0,0,1,.37,1.46v19.2a1.09,1.09,0,0,1-1.63.95,3.23,3.23,0,0,0,4.94-2.66v-19.2a3.27,3.27,0,0,0-.43-1.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "283.61px 298.595px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.4,277.5l16.73,9.6a3.25,3.25,0,0,1,1.64,2.83v19.2a1.09,1.09,0,0,1-1.63.95l-16.73-9.56a3.26,3.26,0,0,1-1.64-2.84V278.44A1.08,1.08,0,0,1,264.4,277.5Z",
    style: {
      fill: "current",
      transformOrigin: "272.77px 293.786px"
    },
    id: "elwzsqrfd2fe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.8,300.33l-4,.75v-5.16l4.16,3.93A.28.28,0,0,1,286.8,300.33Z",
    style: {
      fill: "current",
      transformOrigin: "284.923px 298.5px"
    },
    id: "el5o8v3lezanl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.78,295.92l3.3-1.89,4.16,4a.28.28,0,0,1-.06.44l-3.29,1.84Z",
    style: {
      fill: "current",
      transformOrigin: "286.55px 297.17px"
    },
    id: "el2516d0pbeom",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8ey7gbj3wmi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.78,295.92l3.3-1.89,4.16,4a.28.28,0,0,1-.06.44l-3.29,1.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "286.55px 297.17px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.71,299a4.31,4.31,0,0,0,1.77,2.71l.08,0c.91.52,1.8.26,1.91-.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "272.59px 300.489px"
    },
    id: "elc0hpnu2dfcw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08,294.59a3.33,3.33,0,0,0,.48-1.62c.06-.85.08-1.71.11-2.58.06-1.77.77-2.69,2.15-2.77.33,0,.4-.13.35-.6-.09-.77.13-1.22.65-1.31a1.18,1.18,0,0,1,.8.16,2.76,2.76,0,0,1,.81.77,2.8,2.8,0,0,1,.64,2.06,1,1,0,0,0,.34,1,8.85,8.85,0,0,1,2,4.28,12.25,12.25,0,0,1,.09,1.58,17.59,17.59,0,0,0,.18,2.76,7,7,0,0,0,1,2.75,1.43,1.43,0,0,1,.27.87c0,.45-.18.56-.59.33l-4.83-2.79-3.89-2.25-.5-.29-.51-.3a1,1,0,0,1-.43-.51c-.16-.38-.09-.87.15-1A1.42,1.42,0,0,0,268.08,294.59Zm3.7-.1,1.63.94.42-4.24-2.44-1.41.39,4.71m.81,3.36c.7.4,1.19.12,1.19-.56a2.36,2.36,0,0,0-1.19-1.91c-.7-.41-1.19-.16-1.19.53a2.43,2.43,0,0,0,1.19,1.94m0-10.84a.31.31,0,0,0-.5.29,1.1,1.1,0,0,0,.5.85h0c.26.15.48,0,.48-.29a1.06,1.06,0,0,0-.49-.86",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "272.532px 294.041px"
    },
    id: "elm3arauejegt",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3",
    className: "animable",
    style: {
      transformOrigin: "186.375px 285.863px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.61,325.18,255.7,305.1h0l-2.76-28.92a17.05,17.05,0,0,0-6.52-11.84l-58.84-45.57-3.22-12a3.44,3.44,0,0,0-.65-1.28h0l0,0a.86.86,0,0,0-.13-.14c-3-3.66-7.12-6.77-12.34-6.82h-.28a3.06,3.06,0,0,0-.85.12,3.24,3.24,0,0,0-.82.34l-57.13,33a9.41,9.41,0,0,0-1.15.8l0,0a7.84,7.84,0,0,0-1,.95v0a7.8,7.8,0,0,0-.78,1.1h0a8.06,8.06,0,0,0-.59,1.22h0a8.29,8.29,0,0,0-.36,1.2h0a7.26,7.26,0,0,0-.17,1.24v0a8.58,8.58,0,0,0,0,1.24.08.08,0,0,1,0,0,8,8,0,0,0,.23,1.26l11.37,42.36-4.88-2.92-21,55.74c.78,1.92,2.76.85,2.76.85l6.07-12.74a5.1,5.1,0,0,1,7.16-2.23L174,359.07a13.59,13.59,0,0,1,6.63,9.54l.82,4.84h4l-.19-2A13.61,13.61,0,0,1,192,358.38l55.48-31.94a4.32,4.32,0,0,1,6.41,3l3,17.79a2.29,2.29,0,0,0,2.8-.25Zm-16.74-54.91a8.51,8.51,0,0,1,4,5.88l3.61,21.41a3.37,3.37,0,0,0-1.09-1l-46.4-27a7.56,7.56,0,0,0-.26-1.74l-6.91-25.74ZM119.8,283.69l2.82,10.52-4,2.33a3.26,3.26,0,0,0-1.45,1.7h0c-1.66,3.06-2.25,9.87-.14,14.48l-1.53-.87a7.75,7.75,0,0,1-3.34-9.71l1.52-3.65Zm130.42,24.57,0-.34.05.29Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "176.76px 285.99px"
    },
    id: "eli3nplruytp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.45,348.71l-56.08-32.8a8.52,8.52,0,0,1-3.56-10.62l2.83-6.8h0l-1.52,3.65a7.75,7.75,0,0,0,3.34,9.71l61,34.51A4.09,4.09,0,0,1,170.45,348.71Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "143.309px 323.887px"
    },
    id: "elt2wkge9pfj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.85,280.53l5,3-6.22,15h0l-2.83,6.8a8.52,8.52,0,0,0,3.56,10.62l56.08,32.8a4.09,4.09,0,0,0,6-2.35l4,2.25L255.7,305.1l2.43,25.5-3.95.59-.29-1.73a4.32,4.32,0,0,0-6.41-3L192,358.38a13.61,13.61,0,0,0-6.76,13.09l.19,2h-4l-.82-4.84a13.59,13.59,0,0,0-6.63-9.54l-64.1-36.92a5.1,5.1,0,0,0-7.16,2.23l-6.07,12.74s-2,1.07-2.76-.85Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "176.01px 327px"
    },
    id: "elhwznfsxoecj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.16,217.66l60.26,46.68a17.05,17.05,0,0,1,6.52,11.84L259.69,347a2.29,2.29,0,0,1-2.8.25l-12-71.1a8.51,8.51,0,0,0-4-5.88l-53.26-31.92C180.65,234.2,179.43,219.53,186.16,217.66Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "220.697px 282.637px"
    },
    id: "elb6glaconkf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7p6irohy39p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.16,217.66l60.26,46.68a17.05,17.05,0,0,1,6.52,11.84L259.69,347a2.29,2.29,0,0,1-2.8.25l-12-71.1a8.51,8.51,0,0,0-4-5.88l-53.26-31.92C180.65,234.2,179.43,219.53,186.16,217.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "220.697px 282.637px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.13,298.24h0a3.26,3.26,0,0,1,1.45-1.7L179,261.66a8.37,8.37,0,0,1,8.41,0l60,34.86a3.27,3.27,0,0,1,1.45,1.72h0c1.72,3.18,2.3,10.4-.1,15a3.76,3.76,0,0,1-1.37,1.46L187,349.58a8.4,8.4,0,0,1-8.41,0l-60-34.86a3.36,3.36,0,0,1-1.35-1.48h0C114.83,308.64,115.41,301.42,117.13,298.24Z",
    style: {
      fill: "current",
      transformOrigin: "182.996px 305.618px"
    },
    id: "elmh7zn4xty4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj81gegacnj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.13,298.24h0a3.26,3.26,0,0,1,1.45-1.7L179,261.66a8.37,8.37,0,0,1,8.41,0l60,34.86a3.27,3.27,0,0,1,1.45,1.72h0c1.72,3.18,2.3,10.4-.1,15a3.76,3.76,0,0,1-1.37,1.46L187,349.58a8.4,8.4,0,0,1-8.41,0l-60-34.86a3.36,3.36,0,0,1-1.35-1.48h0C114.83,308.64,115.41,301.42,117.13,298.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "182.996px 305.618px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfr30eiduq59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.13,298.24h0a3.36,3.36,0,0,0,1.44,4.11l60,34.86a8.4,8.4,0,0,0,8.41,0l60.42-34.89a3.34,3.34,0,0,0,1.46-4.08h0c1.72,3.18,2.3,10.4-.1,15a3.76,3.76,0,0,1-1.37,1.46L187,349.58a8.4,8.4,0,0,1-8.41,0l-60-34.86a3.36,3.36,0,0,1-1.35-1.48h0C114.83,308.64,115.41,301.42,117.13,298.24Z",
    style: {
      opacity: 0.3,
      transformOrigin: "182.996px 324.474px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.71,205.5h0l0,0Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "183.71px 205.5px"
    },
    id: "eljk4vjmh6dkb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.14,232l57.13-33a3.39,3.39,0,0,1,1.67-.46h.28c5.22.05,9.31,3.16,12.34,6.82a.86.86,0,0,1,.13.14l0,0a3.44,3.44,0,0,1,.65,1.28l16.39,61A8.13,8.13,0,0,1,197,277l-57.12,33a3.43,3.43,0,0,1-2,.45v0c-6.54-.68-10.39-4.72-12.32-6.85a3.47,3.47,0,0,1-.77-1.43l-16.39-61A8.13,8.13,0,0,1,112.14,232Z",
    style: {
      fill: "current",
      transformOrigin: "154.572px 254.501px"
    },
    id: "elfa2vl3ftwm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3vgan02g48v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.14,232l57.13-33a3.39,3.39,0,0,1,1.67-.46h.28c5.22.05,9.31,3.16,12.34,6.82a.86.86,0,0,1,.13.14l0,0a3.44,3.44,0,0,1,.65,1.28l16.39,61A8.13,8.13,0,0,1,197,277l-57.12,33a3.43,3.43,0,0,1-2,.45v0c-6.54-.68-10.39-4.72-12.32-6.85a3.47,3.47,0,0,1-.77-1.43l-16.39-61A8.13,8.13,0,0,1,112.14,232Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "154.572px 254.501px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9fk46lsypp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.14,232l57.13-33a3.39,3.39,0,0,1,1.67-.46h.28c5.22.05,9.31,3.16,12.34,6.82a3.46,3.46,0,0,0-4.29-.66l-57.13,33a8.13,8.13,0,0,0-3.53,4.18l-10-5.76A8.14,8.14,0,0,1,112.14,232Z",
    style: {
      opacity: 0.1,
      transformOrigin: "146.085px 220.21px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8fzvu7rb39a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.61,241.83a8.06,8.06,0,0,0-.25,5l16.39,61a3.46,3.46,0,0,0,3.08,2.56v0c-6.54-.68-10.39-4.72-12.32-6.85a3.47,3.47,0,0,1-.77-1.43l-16.39-61a8.1,8.1,0,0,1,.27-5Z",
    style: {
      opacity: 0.2,
      transformOrigin: "122.954px 273.25px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.59,342.38A65.46,65.46,0,0,0,237.46,353L235,352a6.47,6.47,0,0,0-7,1.58l-.12.13a2.52,2.52,0,0,1-3.49.16h0a2.5,2.5,0,0,1-.86-1.82l-.34-10.68Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "230.89px 347.933px"
    },
    id: "elgf9q32wvcen",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.91,382.05c5.2,5.57,14.79,10.44,21.75,5.69l-.78,1.77c-7,4.75-16.55-.12-21.75-5.68s-1.83-9.43-6.51-14.37a16.91,16.91,0,0,1-4.05-6c.21-.53.4-1.23.65-2a21.27,21.27,0,0,0,4.18,6.26C227.08,372.63,223.7,376.49,228.91,382.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "234.115px 376.447px"
    },
    id: "elnjxpu90wn1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.78,355.61a10,10,0,0,0,1.64-3.8,2.22,2.22,0,0,1,1-1.54l.06,1.79a2.52,2.52,0,0,0,4.35,1.66l.12-.13a6.47,6.47,0,0,1,7-1.58l2.55,1a2,2,0,0,1,1.27,1.87c-.17,7.3,3.24,17,6.82,22.32,3.68,1.53,6.85,6.54,5.23,10.21l-.16.37c-7,4.75-16.55-.12-21.75-5.69s-1.83-9.42-6.51-14.36a21.27,21.27,0,0,1-4.18-6.26A23,23,0,0,1,220.78,355.61Z",
    style: {
      fill: "current",
      transformOrigin: "234.737px 369.987px"
    },
    id: "eldkfjw8h1fyu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln05ft6g1nvo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.78,355.61a10,10,0,0,0,1.64-3.8,2.22,2.22,0,0,1,1-1.54l.06,1.79a2.52,2.52,0,0,0,4.35,1.66l.12-.13a6.47,6.47,0,0,1,7-1.58l2.55,1a2,2,0,0,1,1.27,1.87c-.17,7.3,3.24,17,6.82,22.32,3.68,1.53,6.85,6.54,5.23,10.21l-.16.37c-7,4.75-16.55-.12-21.75-5.69s-1.83-9.42-6.51-14.36a21.27,21.27,0,0,1-4.18-6.26A23,23,0,0,1,220.78,355.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "234.737px 369.987px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231,366.15a.88.88,0,0,1-1.18-.4.87.87,0,0,1,.36-1.18,10.15,10.15,0,0,1,10,0c.15.57.32,1.14.49,1.71A9.78,9.78,0,0,0,231,366.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "235.193px 364.767px"
    },
    id: "elbowwkpc0n3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.69,362.2a.89.89,0,0,1-.82-1.58,10.68,10.68,0,0,1,10.4.09c.1.59.23,1.19.36,1.79C236.59,360.9,233.53,360.26,229.69,362.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "234.011px 360.907px"
    },
    id: "el77b66zhbod5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.37,370.08a.89.89,0,0,1-1.18-.4.88.88,0,0,1,.37-1.18,10.14,10.14,0,0,1,9.78-.1c.22.62.45,1.22.69,1.82A9.78,9.78,0,0,0,232.37,370.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "236.561px 368.706px"
    },
    id: "elhs96wiglvxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.59,377.16c3.68,1.53,6.85,6.54,5.23,10.21l-.16.37c-6.86,4.68-16.25,0-21.51-5.44C233.53,373.71,242.69,375.85,245.59,377.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "240.202px 382.793px"
    },
    id: "ely33c0wz1nk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,373.91a.88.88,0,0,1-1.18-.4.89.89,0,0,1,.36-1.18,10.17,10.17,0,0,1,9.81-.08c.31.68.63,1.33,1,2C240.82,372.61,237.76,372,233.91,373.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "238.267px 372.639px"
    },
    id: "els3fdovpsvbf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.53,363.6a65,65,0,0,0,3.23,10.13l-2.67.15a6.46,6.46,0,0,0-5.74,4.27l-.06.16a2.52,2.52,0,0,1-3.13,1.55h0a2.47,2.47,0,0,1-1.52-1.31L235,368.91Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "243.88px 371.788px"
    },
    id: "elv3b13qgoead",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.69,403.81c7,3,17.74,3.58,22.19-3.58v1.94c-4.45,7.15-15.18,6.57-22.19,3.58s-5.48-7.89-11.76-10.52a17,17,0,0,1-6.13-3.87c0-.57-.12-1.28-.22-2.11a21.39,21.39,0,0,0,6.35,4.05C251.21,395.93,249.68,400.82,256.69,403.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "258.73px 398.549px"
    },
    id: "el7fqb6owoel3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.58,382.9a10,10,0,0,0,0-4.14,2.24,2.24,0,0,1,.32-1.83l.78,1.62a2.47,2.47,0,0,0,1.52,1.31,2.52,2.52,0,0,0,3.13-1.55l.06-.16a6.46,6.46,0,0,1,5.74-4.27l2.72-.15a2,2,0,0,1,1.91,1.21c2.8,6.74,9.83,14.23,15.25,17.67,4-.1,8.91,3.21,8.91,7.22v.4c-4.45,7.16-15.18,6.57-22.19,3.58s-5.48-7.88-11.76-10.51a21.39,21.39,0,0,1-6.35-4.05A23,23,0,0,1,238.58,382.9Z",
    style: {
      fill: "current",
      transformOrigin: "258.65px 389.82px"
    },
    id: "eluhqa7zbkd4t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqzheidgjqx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.58,382.9a10,10,0,0,0,0-4.14,2.24,2.24,0,0,1,.32-1.83l.78,1.62a2.47,2.47,0,0,0,1.52,1.31,2.52,2.52,0,0,0,3.13-1.55l.06-.16a6.46,6.46,0,0,1,5.74-4.27l2.72-.15a2,2,0,0,1,1.91,1.21c2.8,6.74,9.83,14.23,15.25,17.67,4-.1,8.91,3.21,8.91,7.22v.4c-4.45,7.16-15.18,6.57-22.19,3.58s-5.48-7.88-11.76-10.51a21.39,21.39,0,0,1-6.35-4.05A23,23,0,0,1,238.58,382.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "258.65px 389.82px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.15,388.43a.89.89,0,0,1-1.39-1.12,10.2,10.2,0,0,1,9.16-4c.37.47.75.92,1.14,1.37A9.79,9.79,0,0,0,252.15,388.43Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "255.813px 386.009px"
    },
    id: "el9b99a7vc4j9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.38,385.33a.89.89,0,0,1-1.38-1.11,10.66,10.66,0,0,1,9.55-4.12c.34.5.69,1,1.05,1.49C255.18,381.35,252.12,382,249.38,385.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "253.228px 382.82px"
    },
    id: "elcxxhznhm0kt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,391.45a.89.89,0,0,1-1.38-1.11,10.16,10.16,0,0,1,8.91-4c.45.48.91.94,1.37,1.39A9.78,9.78,0,0,0,255,391.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "258.688px 389.012px"
    },
    id: "elxah28dtjv9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,392.61c4-.1,8.91,3.21,8.91,7.22v.4c-4.39,7-14.86,6.58-21.87,3.71C257.55,394.31,266.79,392.57,270,392.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "267.975px 399.25px"
    },
    id: "elpysuxtsx08n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,394.34a.89.89,0,0,1-1.39-1.11,10.16,10.16,0,0,1,8.94-4c.56.5,1.11,1,1.67,1.41C263.77,390.36,260.71,391,258,394.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "261.827px 391.923px"
    },
    id: "ella3wm41ncof",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.35,272.43,243.44,292a17.38,17.38,0,0,1,8.63,18.36L245.26,347l5.59,17.74C246,371.21,235,371.54,235,371.54c-6.17-12.37-10.7-17.63-14.2-28S214.93,326,214.93,326l-29.14-8a34.53,34.53,0,0,1-25.25-29.38c-.49-4.4-.52-7.41-.52-7.41Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "206.191px 321.985px"
    },
    id: "elvc85y6o5tur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.35,272.43,243.44,292a17.38,17.38,0,0,1,8.63,18.36L245.26,347l5.59,17.74C246,371.21,235,371.54,235,371.54c-6.17-12.37-10.7-17.63-14.2-28S214.93,326,214.93,326l-29.14-8a34.53,34.53,0,0,1-25.25-29.38c-.49-4.4-.52-7.41-.52-7.41Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "206.191px 321.985px"
    },
    id: "eltbkna4mnn2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5p8efbs0elw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.09,282.29A16.59,16.59,0,0,1,204.17,293l24.75,15.5a17.78,17.78,0,0,1,7.58,9.88L245.26,347l-7.9-31.91a14.47,14.47,0,0,0-6.44-8.83l-22.86-14.12C210.4,286.31,208.09,282.29,208.09,282.29Z",
    style: {
      opacity: 0.2,
      transformOrigin: "224.715px 314.645px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.56,212.16h.9c6.06.06,13.73,4.19,17.48,14.76l14.56,28.2-16.62,7.37-9.1-26.61Z",
    style: {
      fill: "current",
      transformOrigin: "221.03px 237.325px"
    },
    id: "elz0fotcypf7c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhk2x9korh69"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "221.03px 237.325px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.56,212.16h.9c6.06.06,13.73,4.19,17.48,14.76l14.56,28.2-16.62,7.37-9.1-26.61Z",
    id: "ell7w8meq2ch8",
    className: "animable",
    style: {
      transformOrigin: "221.03px 237.325px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elnwlp7xqe45a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.23,230.87c1.16,3.33,1.23,6.92,1.42,10.45s.59,7.77,2.2,10.91a10,10,0,0,1,12,.43,9.26,9.26,0,0,1,2.69,3.79l-13.64,6.05-9.1-26.61-4.47-14.68A17,17,0,0,1,216.23,230.87Z",
    style: {
      opacity: 0.2,
      transformOrigin: "220.935px 241.855px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.72,257.41a10,10,0,0,1,7.52-6.08,10.64,10.64,0,0,1,9.26,3.8c1.81,2.19,1.53,5.16.38,7.76a9.68,9.68,0,0,1-11.09,5.25C222.5,266.94,219.1,261.57,220.72,257.41Z",
    style: {
      fill: "current",
      transformOrigin: "229.554px 259.852px"
    },
    id: "elrnohlzjc0c9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elv4roeauux0f"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "229.554px 259.852px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.72,257.41a10,10,0,0,1,7.52-6.08,10.64,10.64,0,0,1,9.26,3.8c1.81,2.19,1.53,5.16.38,7.76a9.68,9.68,0,0,1-11.09,5.25C222.5,266.94,219.1,261.57,220.72,257.41Z",
    id: "el4wuhcj3dxlo",
    className: "animable",
    style: {
      transformOrigin: "229.554px 259.852px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M159.46,284c6.23,6,36.12,7.07,51.37-7.45-1.46-10.25-1-21.23,0-32.09s7.32-29.85-4.8-32.06c-16.19-3.16-24.36-.25-37.58,3.19C156.9,234.83,158.49,263.63,159.46,284Z",
    style: {
      fill: "current",
      transformOrigin: "186.077px 249.603px"
    },
    id: "elma97r8x035e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli0i9dzu9oh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.46,284c6.23,6,36.12,7.07,51.37-7.45-1.46-10.25-1-21.23,0-32.09s7.32-29.85-4.8-32.06c-16.19-3.16-24.36-.25-37.58,3.19C156.9,234.83,158.49,263.63,159.46,284Z",
    style: {
      opacity: 0.2,
      transformOrigin: "186.077px 249.603px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elp91yq5we6b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.15,262.63c-.64-10.68,0-28.85-3.51-34.16L164,225c-5.92,16.39-5.58,36.65-4.84,53.08a62.75,62.75,0,0,0,21,7.52c3.08.57,6.19,1,9.31,1.25,7.83-1.62,15.62-4.87,21.34-10.32-.2-1.37-.35-2.77-.48-4.17a84,84,0,0,1-22.17-4.28A14.74,14.74,0,0,0,177.15,262.63Z",
    style: {
      opacity: 0.2,
      transformOrigin: "184.785px 255.925px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elm2dsb4nc5ul"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.57,283.28v0h0v0s0,0,0-.05,0,0,0-.06l0-.05,0-.06s0,0,0-.06l0-.05h0l10.88-20.25,1.5,1.71-10.88,20.25a1.08,1.08,0,0,0-.14.37h0a.23.23,0,0,0,.05.22h0l-1.5-1.7,0-.08s0-.05,0-.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.15,
      transformOrigin: "209.715px 273.975px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elt1r86rwsz7m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.63,262.57l0-.06,0-.06,0-.06,0-.07,0-.06,0-.07.05-.06,0-.06,0-.06,0,0,0-.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.16-.14,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0l0,0,0,0,0,0,0,0h0l0,0,0,0h0l0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.05,0,.06,0,.07,0,.07,0,.07,0,0,0,12.51-7,0,0,.07,0,.07,0,.07,0,.07,0,.06,0,.07,0,.06,0,.07,0,.07,0h.23a.26.26,0,0,1,.19.08l1.49,1.71c-.06-.08-.19-.1-.37-.06h0a2.83,2.83,0,0,0-.69.28l-12.51,7a6.68,6.68,0,0,0-.71.47h0c-.24.19-.47.38-.69.59h0a6.81,6.81,0,0,0-.59.63h0a3.78,3.78,0,0,0-.41.6l-1.5-1.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "221.455px 260.47px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "173.44 265.69 173.44 265.69 173.44 265.69 173.44 265.69",
    style: {
      fill: "none",
      transformOrigin: "173.44px 265.69px"
    },
    id: "el5qhbwymjnxu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.92,270.27s-7.9,4-11.4,1.8l1.85-3.44a21.52,21.52,0,0,0-13.71,4.66,101.11,101.11,0,0,1-21.74-6.57l-2.48-1-12.57,10.45h0c8.57,5.55,49,9.35,53.2,6.76S221.49,275.2,220.92,270.27Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "190.928px 274.74px"
    },
    id: "el590f1ao3lv4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.46,260.08a24,24,0,0,1,.46,4,14.88,14.88,0,0,1-3.9,8.64,4.39,4.39,0,0,1-1.68,1.18,2,2,0,0,1-1.94-.31,2.89,2.89,0,0,1-.68-2,10.84,10.84,0,0,1,.18-3.27,4.56,4.56,0,0,1,1.72-2.72,10.22,10.22,0,0,1,2.19-1,5.29,5.29,0,0,0,1.95-1.41Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "225.795px 267.052px"
    },
    id: "ellky4eicdrxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.44,265.69h0l.38-33.8a26.67,26.67,0,0,0-3.26-13.08l-2.11-3.21a10.12,10.12,0,0,0-8,5.45,29.13,29.13,0,0,0-3.89,16.6s-1.33,34.84,4.31,38.49l12.57-10.45Z",
    style: {
      fill: "current",
      transformOrigin: "165.123px 245.87px"
    },
    id: "elekybb6g2u6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.88,267.07l-8.44-1.38-12.57,10.45c3.69,2.85,12.53,5.91,18.36,7.34a10.38,10.38,0,0,0,5.42-.13l1-.29L187.58,270A10.51,10.51,0,0,0,181.88,267.07Z",
    style: {
      fill: "current",
      transformOrigin: "174.225px 274.734px"
    },
    id: "elvf5s9xsdru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elio0equ0bql"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "172.002px 249.689px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.44,265.69h0l.38-33.8a26.67,26.67,0,0,0-3.26-13.08l-2.11-3.21a10.12,10.12,0,0,0-8,5.45,29.13,29.13,0,0,0-3.89,16.6s-1.33,34.84,4.31,38.49l12.57-10.45Z",
    id: "elf7tgel3eevb",
    className: "animable",
    style: {
      transformOrigin: "165.123px 245.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.88,267.07l-8.44-1.38-12.57,10.45c3.69,2.85,12.53,5.91,18.36,7.34a10.38,10.38,0,0,0,5.42-.13l1-.29L187.58,270A10.51,10.51,0,0,0,181.88,267.07Z",
    id: "elnz7omv8df3l",
    className: "animable",
    style: {
      transformOrigin: "174.225px 274.734px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M195,272.8c-3.83,1.95-1.87,9.67-1.12,10.26l1.12.1h0a1.91,1.91,0,0,1-1.82.93c-2.05-.21-6.12-.66-7.58-1-3.93-5.91.46-12.24,1.94-13.09,2.4.71,4.75,1.23,6,1.48a1.87,1.87,0,0,1,1.27.94Z",
    style: {
      fill: "current",
      transformOrigin: "189.503px 277.049px"
    },
    id: "eljsmgx5tj5h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eloqcgcnih2xa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195,272.8c-3.83,1.95-1.87,9.67-1.12,10.26l1.12.1h0a1.91,1.91,0,0,1-1.82.93c-2.05-.21-6.12-.66-7.58-1-3.93-5.91.46-12.24,1.94-13.09,2.4.71,4.75,1.23,6,1.48a1.87,1.87,0,0,1,1.27.94Z",
    style: {
      opacity: 0.3,
      transformOrigin: "189.503px 277.049px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.54,213.64a4,4,0,0,0-.1,3.47,8.13,8.13,0,0,0,2.18,2.83,17,17,0,0,0,9.91,4.21,10.4,10.4,0,0,0,5.77-1,5.94,5.94,0,0,0,3.19-4.72,6.22,6.22,0,0,0-3.62-5.49,13.36,13.36,0,0,0-6.78-1,41.86,41.86,0,0,1-6.52.36C183.07,212.08,181.41,212.15,180.54,213.64Z",
    style: {
      fill: "current",
      transformOrigin: "190.791px 218.036px"
    },
    id: "el6wr8ffl9rf4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj3dxe4ub4sl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.54,213.64a4,4,0,0,0-.1,3.47,8.13,8.13,0,0,0,2.18,2.83,17,17,0,0,0,9.91,4.21,10.4,10.4,0,0,0,5.77-1,5.94,5.94,0,0,0,3.19-4.72,6.22,6.22,0,0,0-3.62-5.49,13.36,13.36,0,0,0-6.78-1,41.86,41.86,0,0,1-6.52.36C183.07,212.08,181.41,212.15,180.54,213.64Z",
    style: {
      opacity: 0.3,
      transformOrigin: "190.791px 218.036px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.16,188.51l8.81,13,.22,0-9.4-13.84s-15.09,6.47-14,11.1a1.27,1.27,0,0,1,.06.18h0l.12.3a.36.36,0,0,0,0,.09l.3.76v0a2.47,2.47,0,0,1-.14-.41C164.07,195,179.16,188.51,179.16,188.51Z",
    style: {
      fill: "current",
      transformOrigin: "176.462px 194.59px"
    },
    id: "elzz3nqsav0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elekn3b39asre"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.16,188.51l8.81,13,.22,0-9.4-13.84s-15.09,6.47-14,11.1a1.27,1.27,0,0,1,.06.18h0l.12.3a.36.36,0,0,0,0,.09l.3.76v0a2.47,2.47,0,0,1-.14-.41C164.07,195,179.16,188.51,179.16,188.51Z",
    style: {
      opacity: 0.1,
      transformOrigin: "176.462px 194.59px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188,201.49l-8.81-13s-15.09,6.48-14,11.1a2.47,2.47,0,0,0,.14.41c2.34,5.6,23.25,2.33,23.25,2.33Z",
    style: {
      fill: "current",
      transformOrigin: "176.857px 195.885px"
    },
    id: "elpad5c9ohkur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhtkw5dypmww"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188,201.49l-8.81-13s-15.09,6.48-14,11.1a2.47,2.47,0,0,0,.14.41c2.34,5.6,23.25,2.33,23.25,2.33Z",
    style: {
      opacity: 0.3,
      transformOrigin: "176.857px 195.885px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.89,209.31a54.47,54.47,0,0,1-4.83-12c-1-4.22-3.87-13.59-1.83-17.41,1.54-2.87,5.78-5.77,8.63-7.34s6.58-1.09,9.76-1.78a26,26,0,0,1,8.55-.66c2.85.35,6.44,5.5,8.34,7.66,3,3.4,3.1,8.77.94,12.77s-6.17,6.74-10.45,8.29-8.85,2-13.37,2.49C187.76,203.83,185.76,206.79,183.89,209.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "195.725px 189.664px"
    },
    id: "el8nfg7o5zt7h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.84,167.87c-4.44-4-11.15-4.8-17-3.26-4.95,1.31-10.69,2.84-13.55,7s-1.41,10.08-1.08,16A39.58,39.58,0,0,1,194,179.57c.77-.14,1.56-.24,2.36-.32l-.39-1.94a3.94,3.94,0,0,1,3.61-4.73,17.3,17.3,0,0,1,2.69.06,6,6,0,0,1,5.23,4.61c.2.9.4,1.81.59,2.63a46.86,46.86,0,0,1,6.53,1.64C213.16,176.65,211.63,171.29,207.84,167.87Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "195.085px 175.744px"
    },
    id: "elwpkbevpylu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.36,176.84a30,30,0,0,0-11.48-.34,3.77,3.77,0,0,0,.08.81l.39,1.94a43.53,43.53,0,0,1,11.73.63c-.19-.82-.39-1.73-.59-2.63C207.45,177.11,207.4,177,207.36,176.84Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "201.98px 177.991px"
    },
    id: "elweu1mvhgj2f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.24,208l-.58,6.46a2.51,2.51,0,0,0,.37,1.43,3.65,3.65,0,0,1-.57,4.21,4.82,4.82,0,0,1-2.89,1A14,14,0,0,1,183.9,217a3.06,3.06,0,0,1-.84-2.21l.42-16.38Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "190.756px 209.765px"
    },
    id: "elbztohc8rh7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.24,208l-.58,6.46a2.51,2.51,0,0,0,.37,1.43,3.65,3.65,0,0,1-.57,4.21,4.82,4.82,0,0,1-2.89,1A14,14,0,0,1,183.9,217a3.06,3.06,0,0,1-.84-2.21l.42-16.38Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "190.756px 209.765px"
    },
    id: "elm8hgxdv8hrc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5jfa378w2j9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.29,211.21a11.84,11.84,0,0,0,5.73,2.7,8,8,0,0,0,3.73-.37l.49-5.53-14.76-9.62-.15,6A16.88,16.88,0,0,0,188.29,211.21Z",
    style: {
      opacity: 0.2,
      transformOrigin: "190.785px 206.188px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.73,188a8,8,0,0,0,3.38-3,28.66,28.66,0,0,1-9.2,2.46c1.22-1.06,2.38-2.26,3.6-3.32a39.44,39.44,0,0,1-6.7,1.63,11,11,0,0,0,3.33-2.63,34.59,34.59,0,0,1-11.32,3.09,1.77,1.77,0,0,0-.33.8l-.6,4.65a2.21,2.21,0,0,1-.79,1.74,1.51,1.51,0,0,1-1.68-.27,4.53,4.53,0,0,1-1-1.51,13.36,13.36,0,0,0-1.93-3.26,4.46,4.46,0,0,0-3.31-1.63c-2.07.05-3.65,2.12-3.87,4.18a6.44,6.44,0,0,0,2.39,5.64,6.33,6.33,0,0,0,6,.72c-.94,3.59.94,7.44,3.73,9.88s6.37,3.76,9.86,5c1.91.69,3.93,1.39,5.92,1a7.45,7.45,0,0,0,4.13-2.55,17.33,17.33,0,0,0,2.55-4.23,57.65,57.65,0,0,0,5.28-21.63A14.45,14.45,0,0,1,203.73,188Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "193.226px 198.211px"
    },
    id: "elp928lzacyao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.13 195.32 204.05 203.04 198.94 203.1 201.13 195.32",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "201.495px 199.21px"
    },
    id: "el1adei94sq2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.28,204.59l5.36,2.21a3.42,3.42,0,0,1-3.88,1.37C193.45,207.67,193,206,193.28,204.59Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "195.92px 206.459px"
    },
    id: "elf2je7hl19ji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu43seozvhrp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.28,204.59l5.36,2.21a3.42,3.42,0,0,1-3.88,1.37C193.45,207.67,193,206,193.28,204.59Z",
    style: {
      opacity: 0.3,
      transformOrigin: "195.92px 206.459px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.58,208.23a3.12,3.12,0,0,1-1.82-.06,2.79,2.79,0,0,1-1.56-2.66,3.16,3.16,0,0,1,3.38,2.72Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "194.888px 206.919px"
    },
    id: "elxakuv0dsjc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.91,193.91a1.44,1.44,0,0,0,2.78.78,1.44,1.44,0,1,0-2.78-.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "195.3px 194.3px"
    },
    id: "eldjupza3k0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.43,196.32a1.44,1.44,0,0,0,2.78.78,1.44,1.44,0,1,0-2.78-.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "206.821px 196.705px"
    },
    id: "elampj67hi0ni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.57,189.21l2.48,3a2,2,0,0,0,0-2.35A2.42,2.42,0,0,0,208.57,189.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "210.001px 190.655px"
    },
    id: "el26vyjgy1v7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.8,186.83l-3.68,1.27a2,2,0,0,1,1.21-2A2.43,2.43,0,0,1,195.8,186.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "193.957px 187.056px"
    },
    id: "elg98lpc6u2zs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.4,259.84l60.25,46.68a17,17,0,0,1,6.52,11.84l6.76,70.82a2.29,2.29,0,0,1-2.8.25l-12-71.1a8.5,8.5,0,0,0-4-5.89l-53.26-31.91C107.89,276.38,106.66,261.71,113.4,259.84Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "147.935px 324.817px"
    },
    id: "eljfrmv1wqsi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el131vhcp66z4c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.4,259.84l60.25,46.68a17,17,0,0,1,6.52,11.84l6.76,70.82a2.29,2.29,0,0,1-2.8.25l-12-71.1a8.5,8.5,0,0,0-4-5.89l-53.26-31.91C107.89,276.38,106.66,261.71,113.4,259.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "147.935px 324.817px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.57,283.34s0,.05,0,.07l0,.08,1.5,1.7h0s0-.07,0-.11c.06.26.44.25,1.09-.11l12.51-7a7.14,7.14,0,0,0,2.4-2.28L232,255.41c.17-.34.17-.54,0-.63h.05l-1.49-1.71a.26.26,0,0,0-.19-.08h-.23l-.07,0-.07,0-.06,0-.07,0-.06,0-.07,0-.07,0-.07,0-.07,0,0,0-12.51,7,0,0-.07,0-.07,0-.07,0-.06,0-.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0l0,0,0,0h0l0,0,0,0,0,0,0,0h0l0,0,0,0,0,0,0,0,0,0,0,0,0,0-.16.14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.05,0,0,0,.06,0,.06-.05.06,0,.07,0,.06,0,.07,0,.06,0,.06,0,.06,0,.06-10.88,20.25h0l0,.05s0,0,0,.06l0,.06,0,.05s0,0,0,.06,0,0,0,.05v0h0v.08Zm28.07-28.59.05,0h0s.05,0,.09,0A.34.34,0,0,0,231.64,254.75Zm-14.55,8.36h0l.35-.29Zm-.59.63h0l.15-.16ZM205.07,285h0a1.08,1.08,0,0,1,.14-.37,1.1,1.1,0,0,0-.14.41S205.07,285,205.07,285Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "217.849px 269.125px"
    },
    id: "elym2oiopatqe",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--side-table--inject-3",
    className: "animable",
    style: {
      transformOrigin: "91.505px 337.085px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "130.12 382.03 134.39 384.51 134.37 379.58 130.12 382.03",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "132.255px 382.045px"
    },
    id: "el7qok427rsa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.27 355.72 134.27 355.67 134.27 355.67 134.27 355.67 134.27 355.72",
    style: {
      fill: "rgb(120, 120, 120)",
      transformOrigin: "134.27px 355.695px"
    },
    id: "elvw9fobcu72p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.53,
    y: 343.69,
    height: 47.89,
    style: {
      fill: "rgb(207, 207, 207)",
      transformOrigin: "113.53px 367.635px"
    },
    id: "elf5v6982cn0o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.2 331.73 92.72 355.67 92.72 355.67 134.2 331.73",
    style: {
      fill: "rgb(207, 207, 207)",
      transformOrigin: "113.46px 343.7px"
    },
    id: "el1qo5pn4yfxs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,379.58l0,4.93,4.44-2.56L138.66,324,88.23,353.12l.16,57.94,4.44-2.56v-4.93L130.12,382ZM92.72,355.67h0l41.48-23.94.05,18.79-41.47,24Zm.07,23.94h0l41.48-23.95h0v.06l0,18.74L92.84,398.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "113.52px 367.53px"
    },
    id: "el3nilqnn3s6y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.32 374.46 134.27 355.72 134.27 355.67 92.79 379.61 92.79 379.61 92.84 398.4 134.32 374.46",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "113.555px 377.035px"
    },
    id: "elndpp3ic05tb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.25 350.52 134.2 331.73 92.72 355.67 92.72 355.67 92.78 374.47 134.25 350.52",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "113.485px 353.1px"
    },
    id: "elzcc19eaatb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.23 353.12 44.2 327.53 44.36 385.48 88.39 411.06 88.23 353.12",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "66.295px 369.295px"
    },
    id: "elv0le2423cc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.23 353.12 138.66 324 94.63 298.41 44.2 327.53 88.23 353.12",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "91.43px 325.765px"
    },
    id: "el2fzc8xi7hsl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elddlrou6ol5t"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "130.12 382.03 134.39 384.51 134.37 379.58 130.12 382.03",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "132.255px 382.045px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "134.27 355.72 134.27 355.67 134.27 355.67 134.27 355.67 134.27 355.72",
    style: {
      fill: "rgb(120, 120, 120)",
      transformOrigin: "134.27px 355.695px"
    },
    id: "el1r2915h8u04",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.53,
    y: 343.69,
    height: 47.89,
    style: {
      fill: "rgb(207, 207, 207)",
      transformOrigin: "113.53px 367.635px"
    },
    id: "elgkwhjf68whf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.2 331.73 92.72 355.67 92.72 355.67 134.2 331.73",
    style: {
      fill: "rgb(207, 207, 207)",
      transformOrigin: "113.46px 343.7px"
    },
    id: "elt53ynn29zbp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrtskdyq57p"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "134.32 374.46 134.27 355.72 134.27 355.67 92.79 379.61 92.79 379.61 92.84 398.4 134.32 374.46",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "113.555px 377.035px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elneelcw9qy2b"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "134.25 350.52 134.2 331.73 92.72 355.67 92.72 355.67 92.78 374.47 134.25 350.52",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "113.485px 353.1px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "120.68 346.52 120.66 343.93 106.3 352.22 106.3 352.22 106.31 354.82 120.68 346.52",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "113.49px 349.375px"
    },
    id: "elngzri6offl8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.68 370.13 120.66 367.53 106.3 375.82 106.3 375.82 106.31 378.42 120.68 370.13",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "113.49px 372.975px"
    },
    id: "el7iypimjxzm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc8yfpn1egxe"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "88.23 353.12 44.2 327.53 44.36 385.48 88.39 411.06 88.23 353.12",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "66.295px 369.295px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8n2vzmqicog"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "88.23 353.12 138.66 324 94.63 298.41 44.2 327.53 88.23 353.12",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "91.43px 325.765px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elshbg9fwiyxi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.45,313.36c5.6-3.24,14.65-3.24,20.21,0s5.53,8.47-.07,11.71-14.65,3.23-20.21,0S72.85,316.59,78.45,313.36Z",
    style: {
      opacity: 0.05,
      transformOrigin: "88.52px 319.213px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.59,293l15.36.45,15.37-.45c.66,10.38-1.37,20.95-4.16,26.12h0a7,7,0,0,1-3,3.1c-4.53,2.62-11.86,2.62-16.36,0a6.74,6.74,0,0,1-3-3.18C74.94,313.85,72.93,303.34,73.59,293Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "88.9546px 308.592px"
    },
    id: "eliy7gw23ana8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.13,286.72c-6,3.48-6.06,9.11-.08,12.59s15.71,3.47,21.73,0,6-9.11.07-12.59S84.15,283.25,78.13,286.72Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "88.9468px 293.015px"
    },
    id: "el9cog57whs14",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.51,288.1c-4.7,2.72-4.72,7.11-.06,9.82s12.26,2.71,17,0,4.72-7.1.06-9.82S85.2,285.39,80.51,288.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "88.9875px 293.008px"
    },
    id: "elgpyouhkeco",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8telywm9um8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "88.9875px 293.008px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.51,288.1c-4.7,2.72-4.72,7.11-.06,9.82s12.26,2.71,17,0,4.72-7.1.06-9.82S85.2,285.39,80.51,288.1Z",
    id: "el2ujj5t3apqr",
    className: "animable",
    style: {
      transformOrigin: "88.9875px 293.008px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M90.24,293.45a10.17,10.17,0,0,1-9,2.05,9.45,9.45,0,0,1-6.31-6.39,18.49,18.49,0,0,0,4.93-3.42,12.59,12.59,0,0,0-7,.25,7.13,7.13,0,0,1-.53-6.66,12.2,12.2,0,0,1,8.33-.58,11,11,0,0,0-8.42-2.65,32.27,32.27,0,0,1,2-12.94c5.73.3,11.28,2.76,13.16,4.54a21.22,21.22,0,0,1-.64,6.09,4.93,4.93,0,0,0,2.66-3.94c3.59.9,5.12,2.69,5.68,4.05a15,15,0,0,1-3.39,6.88c3.36-1,4.73-4.77,4.73-4.77C99.77,283.8,99.14,292.68,90.24,293.45Z",
    style: {
      fill: "current",
      transformOrigin: "85.0204px 279.459px"
    },
    id: "elfuirm8jz8po",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7wnorjnr1h2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.24,293.45a10.17,10.17,0,0,1-9,2.05,9.45,9.45,0,0,1-6.31-6.39,18.49,18.49,0,0,0,4.93-3.42,12.59,12.59,0,0,0-7,.25,7.13,7.13,0,0,1-.53-6.66,12.2,12.2,0,0,1,8.33-.58,11,11,0,0,0-8.42-2.65,32.27,32.27,0,0,1,2-12.94c5.73.3,11.28,2.76,13.16,4.54a21.22,21.22,0,0,1-.64,6.09,4.93,4.93,0,0,0,2.66-3.94c3.59.9,5.12,2.69,5.68,4.05a15,15,0,0,1-3.39,6.88c3.36-1,4.73-4.77,4.73-4.77C99.77,283.8,99.14,292.68,90.24,293.45Z",
    style: {
      opacity: 0.2,
      transformOrigin: "85.0204px 279.459px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elp39appoootr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.24,293.45a10.17,10.17,0,0,1-9,2.05,9.45,9.45,0,0,1-6.31-6.39,18.49,18.49,0,0,0,4.93-3.42,12.59,12.59,0,0,0-7,.25,7.13,7.13,0,0,1-.53-6.66,12.2,12.2,0,0,1,8.33-.58,11,11,0,0,0-8.42-2.65,32.27,32.27,0,0,1,2-12.94c5.73.3,11.28,2.76,13.16,4.54a21.22,21.22,0,0,1-.64,6.09,4.93,4.93,0,0,0,2.66-3.94c3.59.9,5.12,2.69,5.68,4.05a15,15,0,0,1-3.39,6.88c3.36-1,4.73-4.77,4.73-4.77C99.77,283.8,99.14,292.68,90.24,293.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "85.0204px 279.459px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.44,294.3h0a.35.35,0,0,0,.31-.36c-.55-7.23-4.69-19.17-14.56-29a.32.32,0,0,0-.46,0,.33.33,0,0,0,0,.47c9.74,9.72,13.82,21.48,14.36,28.6A.32.32,0,0,0,90.44,294.3Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "83.191px 279.572px"
    },
    id: "elwp6xm2jtq2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.73,297.32a9.4,9.4,0,0,0,14.71-3.87,15.81,15.81,0,0,1-4.45-3,12.64,12.64,0,0,1,6.6.2,6.16,6.16,0,0,0,.92-5.94,12.12,12.12,0,0,0-7.86-.47,11.62,11.62,0,0,1,8.15-2.42,26.22,26.22,0,0,0-1.1-11.55c-5.46.33-10.86,2.59-12.74,4.19a17.35,17.35,0,0,0,.22,5.41,4,4,0,0,1-2.26-3.48c-3.42.83-5,2.43-5.57,3.64a11.91,11.91,0,0,0,2.76,6.07A6.77,6.77,0,0,1,83,281.88C79.41,288.83,79.47,296.65,87.73,297.32Z",
    style: {
      fill: "current",
      transformOrigin: "93.3749px 284.856px"
    },
    id: "el0ilsv6hhymzq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el00cj3bx7boqwq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.73,297.32a9.4,9.4,0,0,0,14.71-3.87,15.81,15.81,0,0,1-4.45-3,12.64,12.64,0,0,1,6.6.2,6.16,6.16,0,0,0,.92-5.94,12.12,12.12,0,0,0-7.86-.47,11.62,11.62,0,0,1,8.15-2.42,26.22,26.22,0,0,0-1.1-11.55c-5.46.33-10.86,2.59-12.74,4.19a17.35,17.35,0,0,0,.22,5.41,4,4,0,0,1-2.26-3.48c-3.42.83-5,2.43-5.57,3.64a11.91,11.91,0,0,0,2.76,6.07A6.77,6.77,0,0,1,83,281.88C79.41,288.83,79.47,296.65,87.73,297.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "93.3749px 284.856px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.51,298.11a.34.34,0,0,0,.33-.28c.94-6.3,5.51-16.76,15.32-25.49a.33.33,0,0,0,0-.47.32.32,0,0,0-.46,0c-9.94,8.86-14.58,19.48-15.54,25.89a.33.33,0,0,0,.28.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "95.2077px 284.951px"
    },
    id: "elye7sq9epvy",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3",
    className: "animable",
    style: {
      transformOrigin: "182.105px 113.816px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.29,78.14l-40.33,23a6.08,6.08,0,0,0-3,5.21v37.84a5.93,5.93,0,0,0,9.07,4.88l11.5-6.48.48.78a.27.27,0,0,0,.08.07h0l.06,0h0c.88.58,2.43,1.42,2.78,1.59v0a.33.33,0,0,0,.41-.2l2-5.59h0l23-13.17a6,6,0,0,0,3-5.22V83C208.37,78.69,202,76.59,199.29,78.14Z",
    style: {
      fill: "current",
      transformOrigin: "182.15px 113.801px"
    },
    id: "elj39a2o8rf9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.32,104.82h0Z",
    style: {
      fill: "none",
      transformOrigin: "164.32px 104.82px"
    },
    id: "elg3l171lj5gq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxkdd4qobubp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177,143.41a.27.27,0,0,0,.08.07h0l.06,0h0c.88.58,2.43,1.42,2.78,1.59v0a.31.31,0,0,1-.2-.14l-1.9-3.09.37-.21h0l-1.67,1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "178.22px 143.35px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2mwvncsy2z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.7,106.84a6.14,6.14,0,0,1,1.61-2h0a5.52,5.52,0,0,1,.73-.5l40.32-23a2,2,0,0,1,3,1.74c0-4.33-6.38-6.43-9.08-4.88l-40.33,23a5.93,5.93,0,0,0-2.23,2.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "182.54px 92.2659px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ely9584vlon3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162,147.38V109.54a5.53,5.53,0,0,1,0-.71,6.52,6.52,0,0,1,.63-2l-6-3.39a6,6,0,0,0-.78,2.94v37.84a5.93,5.93,0,0,0,9.07,4.88A2,2,0,0,1,162,147.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "160.385px 126.72px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.78,126.72c-.08,1.8-2,4.77-3.88,5.92l-.16.1c-2,1.15-3.93.58-4.18-1.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "186.67px 130.027px"
    },
    id: "elc2l9e7lulsh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,118.41c.51.19.67,1.26.32,2.11a2.2,2.2,0,0,1-.93,1.11l-1.11.65-1.11.64-8.5,4.9-10.55,6.1c-.88.5-1.25.26-1.29-.72a3.14,3.14,0,0,1,.6-1.89,15.35,15.35,0,0,0,2.21-6,39.39,39.39,0,0,0,.4-6,22.78,22.78,0,0,1,.19-3.46,19.15,19.15,0,0,1,4.46-9.35,2.3,2.3,0,0,0,.74-2.14,7.09,7.09,0,0,1,3.15-6.17,2.59,2.59,0,0,1,1.76-.37c1.14.21,1.62,1.2,1.42,2.88-.12,1,0,1.25.77,1.29,3,.18,4.57,2.2,4.69,6.07.06,1.89.1,3.78.23,5.62a7.36,7.36,0,0,0,1.06,3.55A3,3,0,0,0,198,118.41ZM188.43,117l.86-10.3L184,109.76l.91,9.27,3.55-2m-1.76,7.32a5.32,5.32,0,0,0,2.6-4.22c0-1.52-1.07-2.06-2.61-1.17a5.22,5.22,0,0,0-2.6,4.18c0,1.49,1.08,2.1,2.61,1.21m-.07-23.66a2.38,2.38,0,0,0-1.08,1.87c0,.68.48.95,1.07.62h0a2.38,2.38,0,0,0,1.08-1.86c0-.69-.48-1-1.08-.63",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "186.668px 115.983px"
    },
    id: "elirdw9atrlnm",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificaciones);
export default __webpack_public_path__ + "static/media/notificaciones.17969228.svg";
export { ForwardRef as ReactComponent };